// extracted by mini-css-extract-plugin
export default {"notice":"notice---Zt3R4","info":"info---FRjAk","paragraph":"paragraph---qWd7c"};